<template>
  <div class="d-inline-flex align-center ga-1">
    <v-btn
      icon
      variant="text"
      size="small"
      @click="onPrevious"
      :disabled="disabled || prevDisabled"
    >
      <v-icon :icon="mdiChevronLeft" />
    </v-btn>
    <v-icon
      :icon="mdiCalendarMonth"
      size="small"
      class="text-medium-emphasis"
    />
    <span class="text-body-1 font-weight-medium">{{ monthDescription }}</span>
    <slot></slot>
    <v-btn
      icon
      variant="text"
      size="small"
      @click="onNext"
      :disabled="disabled || nextDisabled"
    >
      <v-icon :icon="mdiChevronRight" />
    </v-btn>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { mdiChevronLeft, mdiChevronRight, mdiCalendarMonth } from "@mdi/js";
import {
  format,
  subMonths,
  addMonths,
  subYears,
  startOfYear,
  isSameMonth,
  isBefore,
  isAfter,
} from "date-fns";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: [Object, Date],
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const currentDate = ref(props.modelValue);
const now = new Date();

watch(
  () => props.modelValue,
  (newValue) => {
    currentDate.value = newValue;
  },
);

const onPrevious = () => {
  currentDate.value = subMonths(currentDate.value, 1);
  emit("update:modelValue", currentDate.value);
};

const onNext = () => {
  currentDate.value = addMonths(currentDate.value, 1);
  emit("update:modelValue", currentDate.value);
};

const monthDescription = computed(() => {
  return format(currentDate.value, "MM/yyyy");
});

const prevDisabled = computed(() => {
  const cutoff = startOfYear(subYears(now, 3));
  return (
    isSameMonth(currentDate.value, cutoff) ||
    isBefore(currentDate.value, cutoff)
  );
});

const nextDisabled = computed(() => {
  return isSameMonth(currentDate.value, now) || isAfter(currentDate.value, now);
});
</script>
